import { useLocation } from 'react-router-dom';
import { CompanyProfileTopBar } from "../../features/CompanyProfile";
import { VendorCompanyTab, VendorLanguageTab, VendorSipHeadersTab } from '../../features/VendorProfile';
import { VendorRoutParam, VendorConnectionType } from "../../models";
import { useFunctionalityVendors } from "../hooks";

export function PageVendorsProfile(): JSX.Element {
  const location = useLocation<VendorRoutParam>();
  const { companyId, vendorName, vendorType } = location?.state;

  return (
    <>
      <CompanyProfileTopBar companyName={vendorName} heading="Vendors" />

      <div className="row mt-4">
        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <div className="profile-tab-container">
                <nav>
                  <div className="nav nav-tabs" id="profile-nav-tab" role="tablist">
                    <a className="nav-link active" id="nav-profile-vendor-company-tab" data-toggle="tab" href="#nav-profile-vendor-company" role="tab" aria-controls="nav-profile-vendor-company" aria-selected="true">Company</a>
                    <a className="nav-link" id="nav-profile-vendor-language-tab" data-toggle="tab" href="#nav-profile-vendor-language" role="tab" aria-controls="nav-profile-vendor-language" aria-selected="false">Language</a>
                    {vendorType === VendorConnectionType.SipUrl &&
                      <a className="nav-link" id="nav-profile-vendor-SIP-tab" data-toggle="tab" href="#nav-profile-vendor-SIP" role="tab" aria-controls="nav-profile-vendor-SIP" aria-selected="false">SIP Headers</a>
                    }
                  </div>
                </nav>
                <div className="tab-content profile-tab-content-container" id="nav-tabContent">
                  <div className="tab-pane fade show active" id="nav-profile-vendor-company" role="tabpanel" aria-labelledby="nav-profile-vendor-company-tab">
                    <VendorCompanyTab parentCompanyId={companyId} />
                  </div>
                  <div className="tab-pane fade show" id="nav-profile-vendor-language" role="tabpanel" aria-labelledby="nav-profile-vendor-language-tab">
                    <VendorLanguageTab />
                  </div>
                  {vendorType === VendorConnectionType.SipUrl &&
                    <div className="tab-pane fade show" id="nav-profile-vendor-SIP" role="tabpanel" aria-labelledby="nav-profile-vendor-SIP-tab">
                      <VendorSipHeadersTab />
                    </div>
                  }

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}